var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgDefaultAvatar6 = function SvgDefaultAvatar6(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 80 80",
    style: {
      enableBackground: "new 0 0 80 80"
    },
    xmlSpace: "preserve"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.6 55.6c5.8 0 10.6-4.6 10.6-10.6 0-5.5-4-9.2-9.4-9.2-2.8 0-5.6 1-7.3 2.9.4-7.4 3-10.8 6.8-10.8 2.6 0 4.3 1.6 5.4 3.3.7.9 1 1.4 1.7 1.4.6 0 1.2-.5 1.2-1.3s-.4-1.9-1.2-3c-1.5-2.1-4.2-3.7-7.4-3.7-6.9 0-11.4 7-11.4 16.4 0 10.1 5.3 14.6 11 14.6zm-6.2-13.9c.9-1.3 3.3-2.4 5.6-2.4 3.9 0 6.6 3.1 6.6 7.1 0 3.6-2.2 6.3-5.6 6.3-3.3-.1-6.4-3.2-6.6-11z"
  })));
};
export default SvgDefaultAvatar6;